import { render, staticRenderFns } from "./paymentCollection.vue?vue&type=template&id=60dbc362&scoped=true&"
import script from "./paymentCollection.vue?vue&type=script&lang=js&"
export * from "./paymentCollection.vue?vue&type=script&lang=js&"
import style0 from "./paymentCollection.vue?vue&type=style&index=0&id=60dbc362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbc362",
  null
  
)

export default component.exports